module.exports = __webpack_public_path__ + "static/logo-577a341bf479846f82e5e617345b4423.png";